//import datos from '../archivo/portal.properties';
import datos from '../source/props/portal.properties';
import {GlobalVariables} from '../utils/globalVariables';

let arrayDatos = [];
const separarString = (value) => value.split(/\r\n|\r|\n/,-1);

const leerArchivoProps = ()=>{
	fetch(datos)
   .then((txt)=>txt.text())
   .then((respuesta)=>{
		console.log(respuesta);
		console.log( 'arrayProps-->',separarString(respuesta));
		arrayDatos = separarString(respuesta);

		//recorrer el array
		arrayDatos.forEach((elemento,index)=>{
			var arrayDeCadenas = elemento.split('=');
			//console.log('index ',index+' elemento--> ' + elemento);
			//for (var i = 0; i < arrayDeCadenas.length; i++) {
			if (arrayDeCadenas[0].substring(0,1) !== '#') {
				if (arrayDeCadenas[0] === 'lab') {
					GlobalVariables.vars.lab = arrayDeCadenas[1].toUpperCase();
					console.log('lab->',arrayDeCadenas[0] + ' :: valor-> ' + GlobalVariables.vars.lab);
				} else {
					if (arrayDeCadenas[0] === 'api') {
						GlobalVariables.vars.api = arrayDeCadenas[1];
						console.log('api->',arrayDeCadenas[0] + ' :: valor-> ' + GlobalVariables.vars.api);
					}
				}
			}
			//}
		});
	});
};
export default {leerArchivoProps};

